import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'
import { saveObj } from 'slices/obj-slice.gen'


const initialState = {
    loadObjownListStatus: 'idle',
    loadObjownListError: undefined as any,
    loadObjownListLastArgs: undefined as any,
    loadObjownStatus: 'idle',
    loadObjownError: undefined as any,
    saveObjownStatus: 'idle',
    saveObjownError: undefined as any,
    deleteObjownStatus: 'idle',
    deleteObjownError: undefined as any,
    loadOwnListStatus: 'idle',
    loadOwnListError: undefined as any,
    loadOwnListLastArgs: undefined as any,

    objownList: [] as any[],
    formItem: undefined as any,
    objOwnList: [] as any,
    ownList: [] as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}

export const sync10WithOldList = createAsyncThunk('ownSubSlice/sync10WithOldList', async ({ obj }: any, { getState, dispatch }) => {
    const { ownSubSlice: { objOwnList } } = getState() as any

    const updObj = { ...obj }

    const nOwners = Math.min(10, objOwnList.length)
    updObj['OWNER_1'] = nOwners

    for (let i = 1; i <= 10; i++) {
        if (i <= nOwners) {
            updObj[`OWNER_${i + 1}`] = objOwnList[i - 1].OWNERNR
            updObj[`P_ANTEIL_${i}`] = objOwnList[i - 1].ANTEIL
        } else {
            updObj[`OWNER_${i + 1}`] = null
            updObj[`P_ANTEIL_${i}`] = null
        }
    }

    dispatch(saveObj({ obj: updObj }))

    return null
})



export const loadObjownList = createAsyncThunk('ownSubSlice/loadObjownList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().ownSubSlice.loadObjownListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/objown/?action=gte&min_ObjNr=${parentModel.OBJNR}&max_ObjNr=${parentModel.OBJNR}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadObjownListStatus } = getState().ownSubSlice
        return loadObjownListStatus !== 'pending'
    }
})

export const loadObjown = createAsyncThunk('ownSubSlice/loadObjown', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/objown/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadObjownStatus } = getState().ownSubSlice
        return loadObjownStatus !== 'pending'
    }
})

export const saveObjown = createAsyncThunk('ownSubSlice/saveObjown', async ({ objown }: any, { rejectWithValue }: any) => {
    let promises = []
    if (objown?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/objown/${ objown?.HDR_ID }/`,
            prepareData(objown),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/objown/`,
            prepareData(objown),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveObjownStatus } = getState().ownSubSlice
        return saveObjownStatus !== 'pending'
    }
})

export const deleteObjown = createAsyncThunk('ownSubSlice/deleteObjown', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/objown/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteObjownStatus } = getState().ownSubSlice
        return deleteObjownStatus !== 'pending'
    }
})

export const loadOwnList = createAsyncThunk('ownSubSlice/loadOwnList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().ownSubSlice.loadOwnListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/own/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadOwnListStatus } = getState().ownSubSlice
        return loadOwnListStatus !== 'pending'
    }
})

const ObjownSlice = createSlice({
    name: 'ownSubSlice',
    initialState,
    reducers: {
        resetloadObjownList: (state) => {
            state.objOwnList = undefined
            state.loadObjownListError = undefined
        },
        resetloadObjownListError: (state) => {
            state.loadObjownListError = undefined
        },
        resetloadObjown: (state) => {
            state.formItem = undefined
            state.loadObjownError = undefined
        },
        resetloadObjownError: (state) => {
            state.loadObjownError = undefined
        },
        resetsaveObjown: (state) => {
            state.formItem = undefined
            state.saveObjownError = undefined
        },
        resetsaveObjownError: (state) => {
            state.saveObjownError = undefined
        },
        resetdeleteObjownError: (state) => {
            state.deleteObjownError = undefined
        },
        resetloadOwnList: (state) => {
            state.ownList = undefined
            state.loadOwnListError = undefined
        },
        resetloadOwnListError: (state) => {
            state.loadOwnListError = undefined
        },
        removeFromObjownListById: (state, action) => {
            state.objownList = state.objownList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromObjownListByIds: (state, action) => {
            state.objownList = state.objownList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        removeFromObjOwnListById: (state, action) => {
            state.objOwnList = state.objOwnList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromObjOwnListByIds: (state, action) => {
            state.objOwnList = state.objOwnList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        removeFromOwnListById: (state, action) => {
            state.ownList = state.ownList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromOwnListByIds: (state, action) => {
            state.ownList = state.ownList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.objownList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadObjownListStatus = 'preloaded'
            state.loadObjownListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.objownList = []
            state.loadObjownListStatus = 'idle'
            state.loadObjownListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadObjownList.pending, (state) => {
            state.loadObjownListStatus = 'pending'
            state.loadObjownListError = undefined
        })
        builder.addCase(loadObjownList.fulfilled, (state, action) => {
            state.loadObjownListStatus = 'idle'

            if (!action.payload) { return }

            state.loadObjownListLastArgs = action.payload.args

            {
                state.objOwnList = action.payload.data

            }
        })
        builder.addCase(loadObjownList.rejected, (state, action) => {
            state.loadObjownListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadObjownListError = action.error.message
            } else {
                state.loadObjownListError = action.payload
            }
        })

        builder.addCase(loadObjown.pending, (state) => {
            state.loadObjownStatus = 'pending'
            state.loadObjownError = undefined
        })
        builder.addCase(loadObjown.fulfilled, (state, action) => {
            state.loadObjownStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.objownList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.objownList.push(newItem) }
                else { state.objownList[i] = { ...state.objownList[i], ...newItem } }
            }
        })
        builder.addCase(loadObjown.rejected, (state, action) => {
            state.loadObjownStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadObjownError = action.error.message
            } else {
                state.loadObjownError = action.payload
            }
        })

        builder.addCase(saveObjown.pending, (state) => {
            state.saveObjownStatus = 'pending'
            state.saveObjownError = undefined
        })
        builder.addCase(saveObjown.fulfilled, (state, action) => {
            state.saveObjownStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.objownList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.objownList.push(newItem) }
                else { state.objownList[i] = { ...state.objownList[i], ...newItem } }
            }
        })
        builder.addCase(saveObjown.rejected, (state, action) => {
            state.saveObjownStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveObjownError = action.error.message
            } else {
                state.saveObjownError = action.payload
            }
        })

        builder.addCase(deleteObjown.pending, (state) => {
            state.deleteObjownStatus = 'pending'
            state.deleteObjownError = undefined
        })
        builder.addCase(deleteObjown.fulfilled, (state, action) => {
            state.deleteObjownStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.objOwnList = state.objOwnList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.objOwnList = state.objOwnList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteObjown.rejected, (state, action) => {
            state.deleteObjownStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteObjownError = action.error.message
            } else {
                state.deleteObjownError = action.payload
            }
        })

        builder.addCase(loadOwnList.pending, (state) => {
            state.loadOwnListStatus = 'pending'
            state.loadOwnListError = undefined
        })
        builder.addCase(loadOwnList.fulfilled, (state, action) => {
            state.loadOwnListStatus = 'idle'

            if (!action.payload) { return }

            state.loadOwnListLastArgs = action.payload.args

            {
                state.ownList = action.payload.data

            }
        })
        builder.addCase(loadOwnList.rejected, (state, action) => {
            state.loadOwnListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadOwnListError = action.error.message
            } else {
                state.loadOwnListError = action.payload
            }
        })

    }
})

export const {
    resetloadObjownList,
    resetloadObjownListError,
    resetloadObjown,
    resetloadObjownError,
    resetsaveObjown,
    resetsaveObjownError,
    resetdeleteObjownError,
    resetloadOwnList,
    resetloadOwnListError,
    removeFromObjownListById,
    removeFromObjownListByIds,
    removeFromObjOwnListById,
    removeFromObjOwnListByIds,
    removeFromOwnListById,
    removeFromOwnListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ObjownSlice.actions
export default ObjownSlice.reducer
